export default "__VITE_ASSET__CqLqWfq0__"